export const responseClientPulse = {
  "early_warning":{
     "metadata":[
        {
         "title":"Internal Regulatory and Compliance Risks",
         "description":"Pertamina’s challenges with internal governance, such as the ongoing investigation and corruption-related charges faced by former executives, could present an ongoing risk to the company’s reputation and operations.",
          "sentiment_flag" : "Negative",
          "source_name": "Indonesiabusinesspost",
      },
      {
         "title":"Strategic Partnerships",
         "description":"Pertamina's strategic partnership with the Philippines' PNOC strengthens its regional presence, unlocking new opportunities and potential growth in the regional energy market​​​",
          "sentiment_flag" : "Positive",
          "source_name": "Reuters"
      }
     ]
  },
  "news":{
     "metadata":[
        {
           "title":"Pertamina Seeks Term Jet Fuel for Early 2025 Delivery",
           "description":"Pertamina is seeking a minimum of 400,000 barrels of jet fuel for delivery between January and March 2025, anticipating lower local production due to refinery maintenance and higher market demand post-Ramadhan​",
           "source_name":"Reuters",
           "sentiment_flag":""
        },
        {
         "title":"Pertamina Unit to Produce ISCC-Certified Sustainable Aviation Fuel in Q1",
         "description":"Kilang Pertamina Internasional, Pertamina's refinery unit, is set to produce its first batch of certified sustainable aviation fuel (SAF) in the first quarter of 2025. The company has received certifications ensuring compliance with international and European Union sustainability standards. The SAF will be produced at the Cilacap refinery using used cooking oil as the primary raw material.​",
         "source_name":"Reuters",
         "sentiment_flag":""
      },
      {
         "title":"PHR Records Lifting of 58 Million Barrels of Oil in 2024 ",
         "description":"PT Pertamina Hulu Rokan (PHR) reported oil lifting reaching 58 million barrels by the end of 2024, reaffirming its energy commitment to Indonesia​",
         "source_name":"Petromindo",
         "sentiment_flag":""

      },
     ]
  },
  "signals":{
      "heading": "The below initiatives position BNI as a strategic partner in achieving Pertamina’s net-zero goals, potentially tapping into global green financing initiatives.",
     "metadata":[
         {
            "title":"",
            "description":"Structured loans or green bonds can be given designed for large-scale biofuel or hydrogen production facilities​",
            "source_name":"",
            "sentiment_flag":""
         },
         {
            "title":"",
            "description":"Support export-driven opportunities in SAF and green hydrogen to regional markets through Trade Finance​",
            "source_name":"",
            "sentiment_flag":""
         },
         {
            "title":"",
            "description":"Develop customized financial instruments to support Pertamina’s scaling strategy, keeping it ahead of domestic competitors in green technology adoption",
            "source_name":"",
            "sentiment_flag":""
         },
     ]
  },
  "analyst_report":{
     "metadata":[
      {
         "title":"IPO’S Fund Allocation",
         "description":"Planning to use 85% of IPO funds for capital expenditure from 2023 to 2025, with a focus on existing and new customers, and digital infrastructure.​​",
         "source_name":"BRI Danareksa Sekuritas",
         "sentiment_flag":""
      },
      {
         "title":"PGEO’s Dividend Policy",
         "description":"Aims to distribute dividends below 50% to enhance shareholder value​​​",
         "source_name":"BRI Danareksa Sekuritas",
         "sentiment_flag":""
      },
      {
         "title":"Market Position and Valuation Buy Recommendation",
         "description":"Current price as of Jan 31st, 2024, is 1,310 with a target price of 1,657, indicating a potential upside of 24.57%.​​",
         "source_name":"BRI Danareksa Sekuritas",
         "sentiment_flag":""
      },
     ]
  },
  "financial_health":{
     "metadata":[
        {
           "title":"\"Semen Information Not Found\"",
           "description":"Based on the provided context, the top 6 focus strategic areas of Semen Indonesia (SIG) are:\n\n1. **Digitao improve production capacity, reduce energy consumption, and increase efficiency.\n5. **Innovation and Research and Development**: SIG encourages innovation and R&D to develop new products, processes, and technologies that can support the company's growth and sustainability, such as the use of alternative fuels and the development of eco-friendly products.\n6. **Supply Chain Optimization and Domestic Component Expenditure**: SIG aims to increase its domestic component expenditure and optimize its supply chain by providing guidance and assistance to local suppliers, particularly small and medium-sized enterprises (SMEs), to support the development of the domestic industry and reduce reliance on imported goods.\n\nThese strategic areas are expected to support SIG's growth, sustainability, and competitiveness in the cement and building materials industry.",
           "file_path":"uploads\\Semen\\News\\news2.pdf",
           "sourceName":"news2.pdf",
           "line_range":"1-24",
           "page_number":1,
           "sentiment_flag":"Neutral"
        }
     ]
  },
  "focus_area":{
   "metadata":[
      {
         "title":"Sustainability",
         "description":"Pertamina is heavily investing in renewable energy to diversify its portfolio It plans to expand its renewable portfolio, targeting 10 GW clean energy capacity by 2026, including geothermal, solar, and wind energy.  Upcoming Projects include Green Hydrogen and Biofuels Expansion​.​​",
         "source_name":"BRI Danareksa Sekuritas",
         "sentiment_flag":"Pertamina Annual Report"
      },
      {
         "title":"Strategic Expansion",
         "description":" Pertamina’s Balikpapan Refinery project is a strategic expansion to increase Indonesia’s refining capacity. The project aims to increase capacity by 100,000 barrels per day, making it the largest refinery in Indonesia, exceeding the capacity of the Cilacap Refinery (345,000 bpd)​​",
         "source_name":"BRI Danareksa Sekuritas",
         "sentiment_flag":"Pertamina Annual Report"
      },
      {
         "title":"Key Growth Areas",
         "description":"Geothermal Development: Pertamina has initiated geothermal development projects to increase its capacity to 1,272 MW in the next 5 years.",
         "source_name":"PertaminaAnnual Report",
         "sentiment_flag":"Pertamina Annual Report"
      },
     ]
},
}